import script from "./UsersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersList.vue?vue&type=script&lang=ts&setup=true"

import "./UsersList.vue?vue&type=style&index=0&id=7122ec30&lang=scss&scoped=true"
script.__scopeId = "data-v-7122ec30"

export default script